import { USERS_ROLE_ENUMS, USER_STORAGE } from "../constants";

export const getUserBaseRoute = (authValue) => {
  const user = getUserFromStorage();
  let role = authValue?.user?.user_role || user?.user?.user_role;
  if (
    [USERS_ROLE_ENUMS.ROOT_ADMIN, USERS_ROLE_ENUMS.POOL_USER].includes(role)
  ) {
    return "pool";
  }
  if ([USERS_ROLE_ENUMS.COMPANY_USER].includes(role)) {
    return "company";
  }
  if (
    [
      USERS_ROLE_ENUMS.AGENT_GENERAL_USER,
      USERS_ROLE_ENUMS.COURTIER_USER,
    ].includes(role)
  ) {
    return "intermediaire";
  }
  if ([USERS_ROLE_ENUMS.COMPANY_AGENCY_USER].includes(role)) {
    return "agency";
  }

  if ([USERS_ROLE_ENUMS.INTERMEDIAIRE_AGENCY_USER].includes(role)) {
    return "intermediaire-agency";
  }

  if ([USERS_ROLE_ENUMS.EXTERNAL_ENTITY_USER].includes(role)) {
    return "pool";
  }

  return false;
};

export const getUserFromStorage = () => {
  try {
    let data = sessionStorage.getItem(USER_STORAGE);
    return JSON.parse(data);
  } catch (error) {
    return null;
  }
};

export const saveUserFromStorage = (data) => {
  try {
    sessionStorage.setItem(USER_STORAGE, JSON.stringify(data));
  } catch (error) {
    sessionStorage.removeItem(USER_STORAGE);
  }
};

export const removeUserFromStorage = () => {
  sessionStorage.removeItem(USER_STORAGE);
};

export const isPoolUser = () => {
  const user = getUserFromStorage();
  return (
    user?.user?.user_role === USERS_ROLE_ENUMS.POOL_USER ||
    user?.user?.user_role === USERS_ROLE_ENUMS.ROOT_ADMIN
  );
};

export const isCompanyUser = () => {
  const user = getUserFromStorage();
  return user?.user?.user_role === USERS_ROLE_ENUMS.COMPANY_USER;
};

export const isIntermediaireUser = () => {
  const user = getUserFromStorage();
  return user?.user?.user_role === USERS_ROLE_ENUMS.INTERMEDIAIRE_AGENCY_USER;
};

export const isRootAdmin = () => {
  const user = getUserFromStorage();
  return user?.user?.user_role === USERS_ROLE_ENUMS.ROOT_ADMIN;
};

export const isAgentGeneralUser = () => {
  const user = getUserFromStorage();
  return user?.user?.user_role === USERS_ROLE_ENUMS.AGENT_GENERAL_USER;
};

export const isCourtierUser = () => {
  const user = getUserFromStorage();
  return user?.user?.user_role === USERS_ROLE_ENUMS.COURTIER_USER;
};

export const isIntermediaireAgencyUser = () => {
  const user = getUserFromStorage();
  return user?.user?.user_role === USERS_ROLE_ENUMS.INTERMEDIAIRE_AGENCY_USER;
};

export const isCompanyAgencyUser = () => {
  const user = getUserFromStorage();
  return user?.user?.user_role === USERS_ROLE_ENUMS.COMPANY_AGENCY_USER;
};

export const getReadableBaseRoute = () => {
  const user = getUserFromStorage();
  let role = user?.user?.user_role;
  if (
    [USERS_ROLE_ENUMS.ROOT_ADMIN, USERS_ROLE_ENUMS.POOL_USER].includes(role)
  ) {
    return "Pool";
  }
  if ([USERS_ROLE_ENUMS.COMPANY_USER].includes(role)) {
    return "Compagnie";
  }
  if (
    [
      USERS_ROLE_ENUMS.AGENT_GENERAL_USER,
      USERS_ROLE_ENUMS.COURTIER_USER,
    ].includes(role)
  ) {
    return "Intermédiaire";
  }
  if ([USERS_ROLE_ENUMS.COMPANY_AGENCY_USER].includes(role)) {
    return "Agence";
  }

  if ([USERS_ROLE_ENUMS.INTERMEDIAIRE_AGENCY_USER].includes(role)) {
    return "Intermédiaire Agence";
  }

  if ([USERS_ROLE_ENUMS.EXTERNAL_ENTITY_USER].includes(role)) {
    return "Entité Externe";
  }

  return false;
};
